import React from "react";
import teamPhoto from "../../assets/About us/Desktop/AboutusBanner.png"; 

import RoundedArrowButton from "../RoundedArrowButton";


const OurTeam = () => {
  return (
    <section className="py-12 md:px-[75px] px-6 bg-[#FFEDA9]">
      <div className="grid grid-cols-1 md:grid-cols-2 items-center gap-8">
        
        {/* Left Column - Heading, Description, Button */}
        <div>
          <h2 className="font-garamond-subheading pb-8 border-b border-[#2C3075] font-normal text-[#2C3075] leading-tight mb-6">
            Our qualified and experienced team
          </h2>
          <p className="font-generalsans-description text-[#2C3075] font-normal md:text-[20px] text-[14px] leading-[110%] mb-6">
         We are dedicated to creating a safe and inclusive environment for all. 
          </p>
         <div className=" py-6 ">
              <RoundedArrowButton label="More about us" to="/aboutus" />
            </div>
        </div>

        {/* Right Column - Image */}
        <div className="flex justify-center md:justify-end">
          <img
            src={teamPhoto}
            alt="Our Team"
            className="w-full max-w-md rounded-[20px] object-cover"
          />
        </div>
      </div>
    </section>
  );
};

export default OurTeam;
